import styled from "styled-components";

export const ChipLayout = styled.div`
  padding: 5px 0;
`;
